import React, { ReactElement } from 'react';
import isEqual from 'lodash.isequal';
import { useDeviceType } from 'b2b-apps/shop/common/hooks';
import { useTranslate } from 'b2b-apps/shop/i18n/hooks';
import { EnhancedComponentProps, EnhancedComponentType, InjectedProps, WrappedComponentType } from './';

const withContainer = (Component: WrappedComponentType): EnhancedComponentType => {
  const WithContainer = (props: EnhancedComponentProps): ReactElement => {
    const t = useTranslate();
    const { stockCount } = props;
    const deviceType = useDeviceType();

    const text = {
      date: t('Date'),
      deliveryDates: t('Expected delivery dates'),
      notReadyForShipment: t('Not ready for shipment'),
      orderedQuantity: t('Ordered Quantity'),
      readyForShipment: t(
        [
          '<strong>1</strong> pc. ready for shipment',
          '<strong>{count}</strong> pcs. ready for shipment',
          'count',
        ],
        {
          count: stockCount,
        },
      ),
      unknownDeliveryDate: t('Delivery date unknown'),
      specialOrder: {
        full: t('Special Order'),
        short: t('S.O.'),
        explanation: t('We do not stock this item, it will be ordered for you after your order. You will receive an email with details about delivery time.'),
      },
      seeMore: t('see more'),
      ...(props.text || {}),
    };

    const injectedProps: InjectedProps = {
      deviceType,
      text,
    };

    return <Component {...props} {...injectedProps} />;
  };

  return React.memo(WithContainer, (prevProps, nextProps) => isEqual(prevProps, nextProps));
};

export { withContainer };
